import { useRef } from 'react';
import './App.css';
import About from './components/about';
import ContactMe from './components/contactMe';
import Expertise from './components/expertise/expertise';
import Home from './components/home';
import Projects from './components/projects';
import Navbar from './components/navbar';
import { Box, Container } from '@mui/material';

function App() {
  const homeRef = useRef<HTMLElement>(null);
  const aboutRef = useRef<HTMLElement>(null);
  const expertiseRef = useRef<HTMLElement>(null);
  const contactMeRef = useRef<HTMLElement>(null);

  return (
    <>
      <Navbar
        homeRef={homeRef}
        aboutRef={aboutRef}
        expertiseRef={expertiseRef}
        contactMeRef={contactMeRef}
      />
        <Box ref={homeRef} >
          <Home />
        </Box>
        <Box ref={aboutRef}>
          <About />
        </Box>
        <Box ref={expertiseRef}>
          <Expertise />
        </Box>
        <Box ref={contactMeRef}>
          <ContactMe />
        </Box>
    </>
  );
}

export default App;
